import * as actionTypes from '../actions/actionTypes';

const initialState = {
    loading: false,
    issueReported: false,
    message: ''
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.REPORT_ISSUE_START:
            return {
                ...state,
                loading: true,
                issueReported: false,
                message: ''
            }
        case actionTypes.REPORT_ISSUE_SUCCESS:
            return {
                ...state,
                loading: false,
                issueReported: true,
                message: action.message
            }
        case actionTypes.REPORT_ISSUE_FAIL:
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
};

export default reducer;